// ── Dual Crew Configuration ──
// All values come from .env (REACT_APP_DUAL_CREW_* and REACT_APP_MQTT_*).

import { MQTT_URL, MQTT_USERNAME, MQTT_PASSWORD } from './mqttConfig';

const DRONE_1_UUID = process.env.REACT_APP_DUAL_CREW_DRONE_1_UUID || '';
const DRONE_2_UUID = process.env.REACT_APP_DUAL_CREW_DRONE_2_UUID || '';
const DRONE_1_CALLSIGN = process.env.REACT_APP_DUAL_CREW_DRONE_1_CALLSIGN || 'Maverick 104';
const DRONE_2_CALLSIGN = process.env.REACT_APP_DUAL_CREW_DRONE_2_CALLSIGN || 'Maverick 105';

const VIDEO_SERVER_BASE_URL = process.env.REACT_APP_DUAL_CREW_VIDEO_SERVER_URL || '';

export const dualCrewConfig = {
  device1Uuid: DRONE_1_UUID,
  device2Uuid: DRONE_2_UUID,
  callsign1: DRONE_1_CALLSIGN,
  callsign2: DRONE_2_CALLSIGN,
  videoUrl1: `${VIDEO_SERVER_BASE_URL}/${DRONE_1_UUID}/whep`,
  videoUrl2: `${VIDEO_SERVER_BASE_URL}/${DRONE_2_UUID}/whep`,
  mqttUrl: MQTT_URL || '',
  mqttUsername: MQTT_USERNAME || '',
  mqttPassword: MQTT_PASSWORD || ''
};
